import EngineCleanupBase from './EngineCleanupBase';
import logService from '../wss/logService3';

export default class EngineBase2 extends EngineCleanupBase {
    _cache = null;
    _name = 'EngineBase2';

    initialize = (name, cache) => {
        try {
            this._cache = cache;

            super.initialize(name);
        } catch (error) {
            logService.logError(`${this._name}.initialize: ${error.message}`);
        }
    };

    isEmpty = () => {
        return this._cache.isEmpty();
    };

    _checkCache = (method) => {
        if (!this._cache) {
            logService.logError(`${this._name}.${method}: cache not initialized`);
            return false;
        }
        return true;
    };

    addOrUpdate = (data) => {
        try {
            if (!this._checkCache('addOrUpdate')) return false;
            return this._cache.addOrUpdate(data);
        } catch (error) {
            logService.logError(`${this._name}.addOrUpdate: ${error.message}`);
            return false;
        }
    };

    deleteEntry = (rk) => {
        try {
            if (!this._checkCache('deleteEntry')) return false;
            return this._cache.delete(rk);
        } catch (error) {
            logService.logError(`${this._name}.deleteEntry: ${error.message}`);
            return false;
        }
    };

    getEntries = () => {
        try {
            if (!this._checkCache('getEntries')) return [];
            return this._cache.getAll();
        } catch (error) {
            logService.logError(`${this._name}.getEntries: ${error.message}`);
            return [];
        }
    };

    clear = () => {
        try {
            if (!this._checkCache('clear')) return;
            this._cache.clear();
        } catch (error) {
            logService.logError(`${this._name}.clear: ${error.message}`);
        }
    };
}
